import { render, staticRenderFns } from "./SendLinkViaWhatsappModal.vue?vue&type=template&id=0b663832&scoped=true"
import script from "./SendLinkViaWhatsappModal.vue?vue&type=script&lang=js"
export * from "./SendLinkViaWhatsappModal.vue?vue&type=script&lang=js"
import style0 from "./SendLinkViaWhatsappModal.vue?vue&type=style&index=0&id=0b663832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b663832",
  null
  
)

export default component.exports